<script setup lang="ts">
import { computed, inject, onUnmounted } from 'vue'
import { useModalStore } from '@/stores/ModalStore'
import UeGlobalModal from '@components/base/UeGlobalModal.vue'
import LogoSelector from './LogoSelector/LogoSelector.vue'
import { useLogoSearchStore } from './LogoSearchStore'
import { Logo } from './LogoSelector/types'

const modalStore = useModalStore()
const logoSearchStore = useLogoSearchStore()
const modalParams = computed(() => modalStore.getModalParams('logo_search_modal') || {})
const title = computed(() => modalParams.value.title || 'Search and pick logos')
const addLogo: (logo: Logo) => void = inject('addLogo')

// Reset store state when modal is unmounted
onUnmounted(() => {
  logoSearchStore.resetState()
})

const handleAddLogo = (): void => {
  if (logoSearchStore.selectedLogo) {
    addLogo(logoSearchStore.selectedLogo)
    logoSearchStore.setSelectedLogo(null)
  }
}
</script>

<template>
  <UeGlobalModal
    :adaptative="true"
    :title="title"
    name="logo_search_modal"
    ref="logoSearchModal"
    width="900px"
    height="700px"
  >
    <LogoSelector />
    <template #footer>
      <div class="d-flex justify-content-between w-100">
        <button
          v-if="logoSearchStore.isInBrandDetailsView"
          class="btn btn-link p-0 fs-sm"
          @click="logoSearchStore.goBackToSearch"
        >
          <i class="bi bi-chevron-left"></i> Back to search
        </button>
        <div v-else></div>
        <button
          class="btn btn-primary fs-sm"
          :disabled="!logoSearchStore.hasSelectedLogo"
          @click="handleAddLogo"
        >
          Add logo
        </button>
      </div>
    </template>
  </UeGlobalModal>
</template>

<style scoped lang="sass">
// Adds borders to the modal body, we need to override the modal_body class because there's no
// current way to customize it. We can probably add some prop(s) to control the borders of the modal later
::v-deep
  .modal_body
    border-bottom: 1px solid var(--border-color)
    border-top: 1px solid var(--border-color)
    padding-bottom: 0 !important
</style>
